import { render, staticRenderFns } from "./UpdateProductPricingModal.vue?vue&type=template&id=a2a15d28&"
import script from "./UpdateProductPricingModal.vue?vue&type=script&lang=js&"
export * from "./UpdateProductPricingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2a15d28')) {
      api.createRecord('a2a15d28', component.options)
    } else {
      api.reload('a2a15d28', component.options)
    }
    module.hot.accept("./UpdateProductPricingModal.vue?vue&type=template&id=a2a15d28&", function () {
      api.rerender('a2a15d28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Billing/components/UpdateProductPricingModal.vue"
export default component.exports